// import { CollezioneNode } from '@gql/graphql'
import { GenericSectionThemeType, MenuItemType } from '@utils/types'
import { CardSwiper } from '@components/organisms'
import styles from './CollezioniSection.module.sass'

interface Props {
  refId?: string
  collezioni: any[] // CollezioneNode[]
  item: MenuItemType
  theme?: GenericSectionThemeType
  handleClickTracking?: (item: any, index: number) => void
  className?: string
}

const CollezioniSection = (props: Props) => {
  const {
    refId = undefined,
    collezioni = [],
    item = undefined,
    theme = 'neutral20',
    handleClickTracking = undefined,
    className = '',
  } = props

  return collezioni?.length > 0 ? (
    <CardSwiper
      id={'collezioni-swiper'}
      refId={refId}
      item={{
        ...(item || {}),
        children: collezioni.map((collezione) => ({
          pk: collezione.pk,
          name: collezione.title,
          image: collezione.listingImage?.url || collezione?.image,
          imageAlt: collezione.listingImage?.imageAlt || '',
          url: collezione.url,
          slug: collezione.slug, // handleClickTracking data
          brand: collezione.brand, // handleClickTracking data
          categoriaEffetto: collezione?.categoriaEffetto, // handleClickTracking data
        })),
      }}
      size="lg"
      theme={theme}
      handleClickTracking={handleClickTracking}
      className={`${styles.root} ${className}`}
    />
  ) : (
    <></>
  )
}

export default CollezioniSection
